var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import internalEvents from './internalEvents';
var handleSearch = function (payload, config) {
    // debugger
    var updatePayload = __assign({}, payload);
    // console.log(updatePayload)
    var searchConfig = config.layout.find(function (layout) { return layout.type === 'search'; });
    if (searchConfig.options.path) {
        var searchVars = updatePayload.search === undefined ? '' : "?search=".concat(updatePayload.search);
        window.location.href = "".concat(searchConfig.options.path).concat(searchVars);
        return; // no need to emit search
    }
    if (updatePayload.birthday ||
        updatePayload.birthmonth ||
        updatePayload.birthyear) {
        // Joint keys
        updatePayload.birthdate = "".concat(updatePayload.birthday || '01', "-").concat(updatePayload.birthmonth || '01', "-").concat(updatePayload.birthyear || '1940');
        // Cleanup
        delete updatePayload.birthday;
        delete updatePayload.birthmonth;
        delete updatePayload.birthyear;
    }
    if (updatePayload.passingday ||
        updatePayload.passingmonth ||
        updatePayload.passingyear) {
        // Joint keys
        updatePayload.passingdate = "".concat(updatePayload.passingday || '01', "-").concat(updatePayload.passingmonth || '01', "-").concat(updatePayload.passingyear || '1940');
        // Cleanup
        delete updatePayload.passingday;
        delete updatePayload.passingmonth;
        delete updatePayload.passingyear;
    }
    // Internal event
    var events = internalEvents(config);
    events.emit('search', updatePayload);
    // dispatch window event
    // Content module / section listen to this event to request data.
    if (window === null || window === void 0 ? void 0 : window._mensenlinqEvents) {
        window._mensenlinqEvents.emit('search', {
            payload: updatePayload,
        });
    }
};
export default handleSearch;
